import styled from 'styled-components';
import { pxToRem } from '@seeneco-ui/core/styles';
const seenecoLogo = require('@seeneco-ui/core/assets/logo/seeneco/full.png');


type InputsLayoutProps = {
	minimalMargin?: boolean;
};

type AuthResultProps = {
	appearance: 'alert' | 'warning' | 'success';
};

const Root = styled.div`
	position: relative;
	width: 100%;
	height: 100vh;
	background-color: #f5f8fa;
	display: flex;
	flex-flow: column nowrap;
`;

const Content = styled.div`
	position: relative;
	width: 540px;
	height: 100%;
	max-width: 100%;
	background-color: #fff;
	box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);
	z-index: 10;
	padding-top: 6px;
	margin: auto;

	@media(min-width: 600px) {
		height: auto;
	}
`;

const ContentLayout = styled.div`
	position: relative;
	padding: 34px 16px;
	min-height: 500px;
	display: flex;
	flex-flow: column nowrap;
	align-items: center;
	justify-content: center;

	@media(min-width: 600px) {
		padding: 44px 100px 34px 100px;
	}
`;

const Title = styled.h1`
	margin: 0;
	margin-bottom: 30px;
	font-size: ${pxToRem(14)};
	line-height: 1.4;
	font-weight: 500;
	text-align: center;
`;

const FormLayout = styled.div`
	width: 100%;
	max-width: 300px;
`;

const CenterLayout = styled.div`
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
`;

const SubmitButtonLayout = styled.div`
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	margin-bottom: 48px;
`;

const InputsLayout = styled.div`
	margin-bottom: 55px;

	${(p: InputsLayoutProps) => p.minimalMargin && `
		margin-bottom: 20px;
	`}
`;

const RecoveryLinkLayout = styled.div`
	width: 100%;
	text-align: center;
`;

const LogoLayout = styled.div`
	position: absolute;
	top: -10vh;
	left: 50%;
	transform: translate(-50%, 0);

	@media(max-width: 640px) {
		top: -35px;
	}

	@media(max-height: 740px) {
		top: -5vh;
	}
`;

const Logo = styled.i`
	display: block;
	width: 240px;
	height: 34px;
	background-position: center;
	background-repeat: no-repeat;
	background-size: cover;
	background-image: url(${seenecoLogo});

	@media(max-width: 640px) {
		width: 150px;
		height: 21px;
	}

	@media(max-height: 740px) {
		width: 150px;
		height: 21px;
	}

	& > u {
		visibility: hidden;
	}
`;

const SupportLinkLayout = styled.div`
	position: absolute;
	bottom: 30px;
	width: 100%;
	text-align: center;

	@media(max-height: 740px) {
		bottom: 10px;
	}
`;

const AuthResultLayout = styled.div`
	width: 100%;
	margin-bottom: 30px;
	display: flex;
	justify-content: center;
`;

const AuthResultMessage = styled.div`
	width: 100%;
	padding: 16px;

	${(p: AuthResultProps) => p.appearance === 'alert' && `
		background-color: #FFCDD2;
		color: #F44336;
	`}

	${(p: AuthResultProps) => p.appearance === 'warning' && `
		background-color: #FFE0B2;
		color: #FF9800;
	`}

	${(p: AuthResultProps) => p.appearance === 'success' && `
		background-color: #C8E6C9;
		color: #43A047;
	`}
`;

const RecoveryButtonLayout = styled(SubmitButtonLayout as any)`
	margin-bottom: 0;
`;

const BackButtonLayout = styled.div`
	position: absolute;
	top: 6px;
	right: 6px;
`;

const TabPickerLayout = styled.div`
	overflow: hidden;
	padding: 6px 40px 6px 40px;
`;

export {
	Root,
	Content,
	ContentLayout,
	Title,
	FormLayout,
	CenterLayout,
	SubmitButtonLayout,
	InputsLayout,
	RecoveryLinkLayout,
	LogoLayout,
	Logo,
	SupportLinkLayout,
	AuthResultLayout,
	AuthResultMessage,
	RecoveryButtonLayout,
	BackButtonLayout,
	TabPickerLayout,
};
